import React from "react";
import { Popconfirm, Space, Tooltip } from "antd";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { useNavigate } from "react-router-dom";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";

const VolunteerTableActions = ({
  opportunities,
  setOpportunities,
  opportunity,
  carePlan,
  setCarePlan,
}) => {
  const navigate = useNavigate();
  const role = useGetRole();

  const handleUnassign = (id) => {
    let updatedFrequencyObj = null;

    if (carePlan?.frequencyPeriod === "slot based") {
      const frequencyData = Array.isArray(carePlan?.frequency)
        ? carePlan.frequency
        : JSON.parse(carePlan?.frequency || "[]");

      if (frequencyData?.[0]?.slots) {
        // Immutable update: clear volunteer from slot
        const slots = frequencyData[0].slots.map((slot) =>
          slot?.assignedVolunteer?.userIdentifier === id
            ? { ...slot, assignedVolunteer: null }
            : slot
        );

        updatedFrequencyObj = [{ ...frequencyData[0], slots }];

        setCarePlan((prevData) => ({
          ...prevData,
          frequency: updatedFrequencyObj,
        }));
      }
    }

    const updatedFrequencyString = updatedFrequencyObj && JSON.stringify(updatedFrequencyObj);

    // Immutable update: set opportunity status to Unassigned when volunteer is removed.
    // This ensures UI and API payload both reflect the removal.
    const remainingOpportunities = opportunities.map((opportunity) => {
      const isUnassigned = opportunity.workforceIdentifier === id;
      return {
        ...opportunity,
        opportunityStatus: isUnassigned ? "Unassigned" : opportunity.opportunityStatus,
        ...(updatedFrequencyString && carePlan?.frequencyPeriod === "slot based" && {
          frequency: updatedFrequencyString,
        }),
      };
    });

    setOpportunities(remainingOpportunities);
  };

  const handleAssign = (id) => {
    const remainingOpportunities = opportunities.map((opportunity) => {
      const isAssigned = opportunity.workforceIdentifier === id;
      return {
        ...opportunity,
        opportunityStatus: isAssigned
          ? "Assigned"
          : opportunity.opportunityStatus,
      };
    });
    setCarePlan((prev) => ({
      ...prev,
      status: "Active",
    }));
    setOpportunities(remainingOpportunities);
  };

  return (
    <Space>
      <Tooltip title="Volunteer Profile" placement="bottom">
        <>
          <SmartIcon
            iconKey={"profile"}
            handleIconClick={() =>
              navigate(
                `${RoleToLinkMapper(role)}volunteer-profile?identifier=${
                  opportunity.workforce.userIdentifier
                }`,
              )
            }
          />
        </>
      </Tooltip>

      {(opportunity.opportunityStatus === "Assigned" || opportunity.opportunityStatus === "Shared") && (
        <Popconfirm
          title="Please confirm if you'd like to remove this volunteer from their current assignment."
          placement="top"
          onConfirm={() => handleUnassign(opportunity.workforceIdentifier)}
          okText="Confirm"
          cancelText="Cancel"
          overlayClassName="article-delete-popconfirm"
        >
          <Tooltip title="Unassign" placement="bottom">
            <>
              <SmartIcon iconKey={"reject"} />
            </>
          </Tooltip>
        </Popconfirm>
      )}

      {opportunity.opportunityStatus === "Shared" && (
        <Tooltip title="Assign" placement="bottom">
          <>
            <SmartIcon
              iconKey="volunteerRequest"
              handleIconClick={() =>
                handleAssign(opportunity.workforceIdentifier)
              }
            />
          </>
        </Tooltip>
      )}
    </Space>
  );
};

export default VolunteerTableActions;
